import apiService from './apiService';

/**
 * Ecommerce Video Shorts Service
 * Fetches configured video shorts from the public /api/ecommerce/video-shorts endpoint
 */
class VideoShortsService {
    /**
     * Fetch active video shorts configured by admin for the storefront.
     * Expected endpoint: GET /api/ecommerce/video-shorts
     *
     * Response shape:
     *   {
     *     success: true,
     *     data: {
     *       videoShorts: [
     *         {
     *           _id: "...",
     *           title: "...",
     *           caption: "...",
     *           video_url: "...",
     *           thumbnail_url: "...",
     *           badge: "...",
     *           display_order: 1,
     *           is_active: true
     *         }
     *       ]
     *     }
     *   }
     *
     * Also supports alternative backend response keys gracefully:
     *   - data.shorts
     *   - data.videos
     *   - data (array)
     *   - response (array)
     *
     * @param {object} params - Optional query parameters (e.g. { active_only: true })
     * @returns {Promise<Array>} Array of raw video short objects
     */
    async getAll(params = {}) {
        try {
            const response = await apiService.get('/ecommerce/video-shorts', params);

            // Flexibly extract array across various standard response envelopes
            const candidates = [
                response?.data?.videoShorts,
                response?.data?.shorts,
                response?.data?.videos,
                response?.videoShorts,
                response?.shorts,
                response?.videos,
                Array.isArray(response?.data) ? response.data : null,
                Array.isArray(response) ? response : null,
            ];

            const list = candidates.find((arr) => Array.isArray(arr));
            return list || [];
        } catch (error) {
            console.warn(
                '[VideoShortsService] Failed to load video shorts from API:',
                error?.message || error
            );
            throw error;
        }
    }
}

const videoShortsService = new VideoShortsService();
export default videoShortsService;
